var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    height: 13,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    width: 24,
    height: 24,
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.75 3.25-6.5 6.5",
    style: {
      fill: "none"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.75 3.25-6.5 6.5",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(222, 100, 100)",
      strokeOpacity: 1
    },
    className: "stroke-shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.25 3.25 6.5 6.5",
    style: {
      fill: "none"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.25 3.25 6.5 6.5",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(222, 100, 100)",
      strokeOpacity: 1
    },
    className: "stroke-shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3a067812caf6dc8f889c815e8472ba85.svg";
export { ForwardRef as ReactComponent };